import React from 'react';
import ReactDOM from 'react-dom';
import find from 'lodash.find';

const Movable = ({ handlers: selectors } = {}) => {
  const handlerStyle = {
    cursor: 'move'
  };

  const handlerAttrs = {
    draggable: true
  };

  const styleKeys = Object.keys(handlerStyle);
  const attrsKeys = Object.keys(handlerAttrs);

  return (Component) => React.createClass({
    componentDidMount() {
      this.deltaX = 0;
      this.deltaY = 0;

      this.el = ReactDOM.findDOMNode(this);

      if (this.el.getAttribute('draggable')) {
        return;
      }

      this.el.setAttribute('draggable', 'true');
      let handlers = Array.prototype.filter.call(
        this.el.querySelectorAll(selectors), el => !el.hasAttribute('draggable'));

      /**
       * Prevent from click when dragging ends (Firefox and IE10).
       */
      this.el.addEventListener('dragstart', this.onDragStart, false);

      if (handlers.length === 0) {
        handlers = [this.el];
      }

      this.handlers = handlers;
      this.handlers.forEach(el => {
        styleKeys.forEach(p => el.style[p] = handlerStyle[p]);
        attrsKeys.forEach(p => el.setAttribute(p, handlerAttrs[p]));
      });
    },

    componentWillUnmount() {
      this.el.removeEventListener('dragstart', this.onDragStart, false);
      this.el = null;
    },

    preventClick(e) {
      e.stopPropagation();
    },

    onDragStart(e) {
      if (e.button !== 0 || !find(this.handlers, h => e.target === h)) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      this.initialX = e.clientX;
      this.initialY = e.clientY;

      this.el.addEventListener('click', this.preventClick, false);

      this.lastDocumentCursor = document.body.style.cursor;
      document.body.style.cursor = 'move';

      document.addEventListener('mousemove', this.onMouseMove, false);
      document.addEventListener('mouseup', this.onMouseUp, false);
    },

    onMouseMove(e) {
      const x = this.deltaX + e.clientX - this.initialX,
            y = this.deltaY + e.clientY - this.initialY;

      this.el.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    },

    onMouseUp(e) {
      this.deltaX += e.clientX - this.initialX;
      this.deltaY += e.clientY - this.initialY;

      setTimeout(() => {
        this.el.removeEventListener('click', this.preventClick, false);
      }, 0);

      document.body.style.cursor = this.lastDocumentCursor;

      document.removeEventListener('mousemove', this.onMouseMove, false);
      document.removeEventListener('mouseup', this.onMouseUp, false);
    },

    render() {
      return <Component {...this.props} />
    }
  });
};

export default Movable;



// WEBPACK FOOTER //
// ./app/header-builder/HOCs/Movable.js